import Vue from 'vue'
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
import enLocale from 'element-ui/lib/locale/lang/en'
import ElementLocale from 'element-ui/lib/locale'
import VueI18n from 'vue-i18n'
// import {zhCN} from "./zh";
// import {en} from "./en";
import zh from "./zh";
import en from "./en";
//element能修改的文字均没有内含语言包,需要手动添加语言包
Vue.use(VueI18n)

const i18n = new VueI18n({
  // locale: 'en', //默认语言
  locale: 'zh-cn', //默认语言
  messages: {
    'zh-cn': Object.assign(zh, zhLocale),
    'en': Object.assign(en, enLocale)
  } // set locale messages
})
ElementLocale.i18n((key, value) => i18n.t(key, value))
export default i18n



// WEBPACK FOOTER //
// ./src/lang/i18n.js